import React from 'react'
import'./notifications.css'

function Notifications() {
  return (
    <div>Notifications</div>
  )
}

export default Notifications